import { Box } from "@mui/material"
import { cloneElement } from "react"

interface IProps {
  fields: JSX.Element[]
  key?: number
}

const FormRow = ({fields, key}:IProps) => {
  return (
    <Box key={key} width={"100%"} display={'flex'} justifyContent={'space-between'}>
      {fields.map((field, index) => cloneElement(field, {key: index + 1}))}
    </Box>
  )
}

export default FormRow